<div (click)="handlePayGroupClick()" class="information-container flex flex-row flex-align-center-space-between">
	<!-- Title -->
	<div class="title-container flex flex-column">
		<div
			class="information-title-container"
			[matTooltip]="
				accountStatusByPayGroup.externalLegalEntityId +
				'/' +
				accountStatusByPayGroup.payGroupName +
				'/' +
				accountStatusByPayGroup.externalPayGroupId
			"
			[matTooltipPosition]="'above'"
			[matTooltipClass]="'pay-elective-list-item'"
		>
			<span class="information-title legal-entity-flag">
				<img src="assets/svg-country-flags/svg/{{ accountStatusByPayGroup.countryCode.toLowerCase() }}.svg" />
			</span>

			<span class="information-title legal-entity-id">
				{{ accountStatusByPayGroup.externalLegalEntityId }}
			</span>
			<span class="information-title">/</span>
			<span class="information-title paygroup-name">{{ accountStatusByPayGroup.payGroupName }}</span>
			<span class="information-title">/</span>
			<span class="information-title paygroup-id"> {{ accountStatusByPayGroup.externalPayGroupId }}</span>
		</div>
		<div class="detail-container">
			<!-- Dot -->
			<div
				class="dot"
				[ngClass]="{
					warning: accountStatusByPayGroup.status === 'IMPLEMENTATION',
					success: accountStatusByPayGroup.status === 'LIVE',
					danger: accountStatusByPayGroup.status === 'INACTIVE'
				}"
			></div>
			<div class="text-status">{{ accountStatusByPayGroup.status }}</div>
		</div>
	</div>
	<div class="data-container" *ngIf="accountStatusByPayGroup.stats != null">
		<div class="employee-info flex flex-column flex-align-start flex-1" style="--max-width: 80%">
			<div class="flex flex-column flex-align-start">
				<div class="employee-title">{{ accountStatusByPayGroup.totalEmployees }} Employees</div>
				<div class="information-subtitle-text">
					{{ accountStatusByPayGroup.totalBeneficiaries }}
					{{ accountStatusByPayGroup.totalBeneficiaries === 1 ? "Beneficiary" : "Beneficiaries" }}
				</div>
			</div>
		</div>
		<div class="flex flex-row flex-1 flex-align-center-center" style="--max-width: 20%">
			<div
				[ngClass]="{ disabled: accountStatusByPayGroup.stats.payMethodsErrorCount === 0 }"
				class="flex flex-column flex-gap"
				style="--gap: 10px"
			>
				<div class="flex flex-row flex-align-center-center flex-gap" style="--gap: 6px">
					<div
						*ngIf="
							accountStatusByPayGroup.stats.payMethodsErrorCount != null &&
							accountStatusByPayGroup.stats.payMethodsErrorCount > 0
						"
						class="error-circle"
					>
						<span>+</span>
					</div>
					<app-icon class="icon ben" [size]="'22'" [name]="'2user'"></app-icon>
					<span
						*ngIf="
							accountStatusByPayGroup.stats.payMethodsErrorCount != null &&
							accountStatusByPayGroup.stats.payMethodsErrorCount > 0
						"
						class="counts"
					>
						{{ accountStatusByPayGroup.stats.payMethodsErrorCount }}
					</span>
				</div>
				<div class="flex flex-row flex-align-center-center">
					<span class="icon-text">Beneficiaries</span>
				</div>
			</div>
		</div>
		<div class="flex flex-row flex-1 flex-align-center-center" style="--max-width: 20%">
			<div
				[ngClass]="{ disabled: accountStatusByPayGroup.stats.employeesWithNoCardCount === 0 }"
				class="flex flex-column flex-gap"
				style="--gap: 10px"
			>
				<div class="flex flex-row flex-align-center-center flex-gap" style="--gap: 6px">
					<div
						*ngIf="
							accountStatusByPayGroup.stats.employeesWithNoCardCount != null &&
							accountStatusByPayGroup.stats.employeesWithNoCardCount > 0
						"
						class="warning-circle"
					>
						<span>!</span>
					</div>
					<app-icon class="icon card" [size]="'22'" [name]="'card'"></app-icon>
					<span
						*ngIf="
							accountStatusByPayGroup.stats.employeesWithNoCardCount != null &&
							accountStatusByPayGroup.stats.employeesWithNoCardCount > 0
						"
						class="counts"
					>
						{{ accountStatusByPayGroup.stats.employeesWithNoCardCount }}
					</span>
				</div>
				<div class="flex flex-row flex-align-center-center">
					<span class="icon-text">Cards</span>
				</div>
			</div>
		</div>
		<div class="flex flex-row flex-align-center-center flex-1" style="--max-width: 20%">
			<div
				[ngClass]="{ disabled: accountStatusByPayGroup.stats.employeesWithNoAccountCount === 0 }"
				class="flex flex-column flex-gap"
				style="--gap: 10px"
			>
				<div class="flex flex-row flex-align-center-center flex-gap" style="--gap: 6px">
					<div
						*ngIf="
							accountStatusByPayGroup.stats.employeesWithNoAccountCount != null &&
							accountStatusByPayGroup.stats.employeesWithNoAccountCount > 0
						"
						class="warning-circle"
					>
						<span>!</span>
					</div>
					<app-icon class="icon" [size]="'22'" [name]="'bank-figma'"></app-icon>
					<span
						*ngIf="
							accountStatusByPayGroup.stats.employeesWithNoAccountCount != null &&
							accountStatusByPayGroup.stats.employeesWithNoAccountCount > 0
						"
						class="counts"
					>
						{{ accountStatusByPayGroup.stats.employeesWithNoAccountCount }}
					</span>
				</div>
				<div class="flex flex-row flex-align-center-center">
					<span class="icon-text">Bank Accounts</span>
				</div>
			</div>
		</div>
	</div>
</div>
